<template>
    <div>
        <update-card
        v-if="user"
        :user="user"
        :label="$t('parametres.perso.nom')"
        keyname="nom"
        input-type="text"
        />
        <update-card
        v-if="user"
        :user="user"
        :label="$t('parametres.perso.prenom')"
        keyname="prenom"
        input-type="text"
        />
        <update-card
        v-if="user"
        :user="user"
        :label="$t('parametres.perso.telephone')"
        keyname="tel"
        input-type="tel"
        />
    </div>
</template>

<script>
import UpdateCard from './../components/UpdateCard.vue'
export default {
    components: {UpdateCard},
    props: {
        user: {
            required: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/settings/PersonnalSettingsSection.vue